export const TAG_COLORS = {
  red: "#F44336",
  maroon: "#B71C1C",
  rust: "#E64A19",
  orange: "#FF9800",
  gold: "#F9A825",
  olive: "#9E9D24",
  sage: "#689F38",
  green: "#4CAF50",
  forest: "#2E7D32",
  teal: "#009688",
  cyan: "#00ACC1",
  sky: "#0288D1",
  blue: "#2196F3",
  navy: "#1565C0",
  indigo: "#3F51B5",
  violet: "#673AB7",
  purple: "#9C27B0",
  magenta: "#C2185B",
  pink: "#E91E63",
  plum: "#880E4F",
  brown: "#795548",
  slate: "#607D8B",
  grey: "#9E9E9E",
  charcoal: "#424242",
};

/**
 * The first colour none of the existing items holds, falling back to a cycle once all are taken.
 * @param {string[]} takenColors the colour names already in use
 * @returns {string} a TAG_COLORS key
 */
export function freshTagColor(takenColors) {
  const names = Object.keys(TAG_COLORS);
  const taken = new Set(takenColors);
  return names.find((name) => !taken.has(name)) ?? names[takenColors.length % names.length];
}

// Frozen at the original 7-colour palette: order and length drive stable per-user avatar assignment.
export const AVATAR_COLORS = Object.freeze([
  TAG_COLORS.green,
  TAG_COLORS.blue,
  TAG_COLORS.teal,
  TAG_COLORS.purple,
  TAG_COLORS.orange,
  TAG_COLORS.red,
  TAG_COLORS.grey,
]);
